import React, { Component } from "react";
import * as pageData from "./PageData";

const hashedLine = "###############";
const longLine = "---------------";
const shortLine = "----------";
const minimumTimeInMs = 20;
const timeIncrementInMs = 20;

var lastCorrect = false;
var correctInARow = 0;
var pushAfterTwoCorrect = false;
var currentTimeInMs = 200;

var nextData = null;

export default class InspectionTime extends Component {
    static getDerivedStateFromProps(props, state) {
        if (state.index === props.index) {
            return null;
        }

        return {
            index: props.index,
            disableButtons: false
        };
    }

    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
        this.interceptClick = this.interceptClick.bind(this);
        this.state = {
            index: 0,
            disableButtons: false,
            hashed: false,
            topLineLonger: Math.floor(Math.random() * 2) === 0
        };
    }

    componentDidMount() {
        this.afterUpdate();

        setTimeout(() => {
            this.setState({ hashed: true });
        }, currentTimeInMs);
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);
    }

    interceptClick(type) {
        if (type === "next") {
            if (nextData) {
                this.props.next(nextData);
                nextData = null;
            }

            this.props.setDisableNext();
            this.setState({ disableButtons: false, hashed: false, topLineLonger: Math.floor(Math.random() * 2) === 0 });
            setTimeout(() => {
                this.setState({ hashed: true });
            }, currentTimeInMs);

            return true;
        }

        return false;
    }

    buttonClick(type) {
        const correct = this.state.topLineLonger === (type === "top");

        if (correct) {
            correctInARow++;

            if (correctInARow === 2) {
                if (pushAfterTwoCorrect || currentTimeInMs === minimumTimeInMs) {
                    nextData = { timeInMs: currentTimeInMs };
                    pushAfterTwoCorrect = false;
                }

                if (currentTimeInMs - timeIncrementInMs >= minimumTimeInMs) {
                    currentTimeInMs -= timeIncrementInMs;
                }

                correctInARow = 0;
            }
        }
        else {
            if (lastCorrect) {
                nextData = { timeInMs: currentTimeInMs };
                pushAfterTwoCorrect = true;
            }

            currentTimeInMs += timeIncrementInMs;
            correctInARow = 0;
        }

        lastCorrect = correct;

        this.props.clearDisableNext();
        this.setState({ disableButtons: true });
    }

    render() {
        const progressStyle = {
            width: `${this.props.index * (100 / pageData.inspectionTimeTestPages)}%`
        };

        return (
<div className="test-page-content-inner test-page-inspection-time">
    <div className="test-content">
        <div className="content-col-1">
            {renderLines(this.state.hashed, this.state.topLineLonger)}
        </div>
        <div className="content-col-2">
            {renderButtons(this.state.disableButtons, this.buttonClick)}
        </div>
    </div>
    <div className="progress">
        <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
    </div>
</div>
        );
    }
}

function renderLines(hashed, topLineLonger) {
    return (
<React.Fragment>
    <div className="line-1">{hashed ? hashedLine : topLineLonger ? longLine : shortLine}</div>
    <div className="line-2">+</div>
    <div className="line-3">{hashed ? hashedLine : topLineLonger ? shortLine : longLine}</div>
</React.Fragment>
    );
}

function renderButtons(disableButtons, buttonClick) {
    const disabled = disableButtons ? 'disabled' : '';
    return (
<React.Fragment>
    <button className="btn btn-choose-line button-1" onClick={() => buttonClick("top")} disabled={disableButtons}>TOP LINE LONGER</button>
    <button className="btn btn-choose-line button-2" onClick={() => buttonClick("bottom")} disabled={disabled}>BOTTOM LINE LONGER</button>
</React.Fragment>
    );
}
